/* eslint-disable i18next/no-literal-string */
import type { ComponentPropsWithoutRef, FC } from "react";
import { LuAppWindow, LuGlobe, LuKey, LuMapPin, LuMonitor, LuTag } from "react-icons/lu";
import type { GlobalSettings } from "@/features/diagnostics/types";
import type { Nullable } from "@/types";
import {
    DiagnosticsCard,
    DiagnosticsCardHeader,
    DiagnosticsCardIcon,
    DiagnosticsCardLabel,
    DiagnosticsCardNull,
    DiagnosticsCardValue,
} from "../lib/diagnostics-card.tsx";

type GlobalsItemProps = {
    global: keyof GlobalSettings;
    value: Nullable<string>;
};

const CONFIG: Record<keyof GlobalSettings, { icon: FC<ComponentPropsWithoutRef<"svg">>; label: string }> = {
    mode: {
        icon: LuMonitor,
        label: "Mode",
    },
    site: {
        icon: LuGlobe,
        label: "Site",
    },
    locale: {
        icon: LuMapPin,
        label: "Locale",
    },
    configurationTab: {
        icon: LuAppWindow,
        label: "Configuration tab",
    },
    property: {
        icon: LuTag,
        label: "Property",
    },
    apiTokenUrl: {
        icon: LuKey,
        label: "API token URL",
    },
};

export default function GlobalsItem({ global, value }: GlobalsItemProps) {
    return (
        <DiagnosticsCard variant="info">
            <DiagnosticsCardHeader>
                <DiagnosticsCardIcon icon={CONFIG[global].icon} />
                <DiagnosticsCardLabel>{CONFIG[global].label}</DiagnosticsCardLabel>
            </DiagnosticsCardHeader>
            <DiagnosticsCardValue>{value ?? <DiagnosticsCardNull>null</DiagnosticsCardNull>}</DiagnosticsCardValue>
        </DiagnosticsCard>
    );
}
